import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';
import * as React from 'react';
import CommitDiffContainer from '../../../../shared/containers/CommitDiffContainer';

type Props = {
  readonly baseCommitId?: string;
  readonly commitId?: string;
};

export const DiffViewContainer = (props: Props) => {
  const { baseCommitId, commitId } = props;

  return (
    <Grid item xs={12} sx={{ m: 2 }}>
      <Grid item display="flex" justifyContent="center">
        <Typography variant="h5" style={{ margin: '10px 0' }}>Preview changes</Typography>
      </Grid>

      <Grid item xs={12}>
        <CommitDiffContainer
          baseCommitId={baseCommitId}
          commitId={commitId}
          showAffectedFilesInfo
        />
      </Grid>
    </Grid>
  );
}

export default DiffViewContainer;
